<template>
	<SectionContainer
		ref="sectionContainer"
		:isExpandable="true"
		class="company-advanced"
	>
		<template #left>
			<h4>Advanced</h4>
		</template>
		<template #right>
			<div v-if="editMode">
				<Button
					className="btn--icon-only"
					iconClassName="icon-more"
					:iconBeforeLabel="true"
				/>
				<Button
					className="btn--icon-only"
					iconClassName="icon-unsaved"
					:iconBeforeLabel="true"
				/>
				<Button
					className="btn--icon-only"
					iconClassName="icon-close"
					:iconBeforeLabel="true"
					:btnClick="handleEditMode"
				/>
			</div>
			<Button
				v-if="!editMode"
				className="btn--icon-only"
				iconClassName="icon-edit"
				:iconBeforeLabel="true"
				:btnClick="handleEditMode"
			/>
		</template>
		<template #content>
			<!-- DEV NOTE: HorizontalScrolling component is not working at the moment. Update this piece after is ready -->
			<!-- <HorizontalScrolling
				:source="carouselSource"
				:component="carouselComponent"
			/> -->
			<!-- TO BE REMOVE: remove when HorizontalScrolling component is fixed -->
			<CompanyAdvancedCard :item="data" v-if="!editMode" />
			<CompanyAdvancedCardEdit v-model="localData" v-else />
			<Modal
				:display="true"
				:isConfirmation="true"
				v-if="closeWithOutSaving"
			>
				<template #modal-content>
					Are you sure you want to close this section without saving?
				</template>
			</Modal>
		</template>
	</SectionContainer>
</template>

<script>
import SectionContainer from '@/components/shells/section-container/section-container';
import Button from '@/components/forms/button/button';
import Modal from '@/components/shells/modal/modals';
import CompanyAdvancedCard from './company-advanced-card.vue';
import CompanyAdvancedCardEdit from './company-advanced-card-edit.vue';
import _ from 'lodash';

export default {
	name: 'CompanyAdvanced',
	components: {
		SectionContainer,
		Button,
		Modal,
		CompanyAdvancedCard,
		CompanyAdvancedCardEdit
	},
	props: {
		data: {
			type: Object,
			default: () => {}
		}
	},
	data() {
		return {
			localData: _.cloneDeep(this.data),
			closeWithOutSaving: false,
			editMode: false
		};
	},
	methods: {
		handleEditMode() {
			this.editMode = !this.editMode;
		}
	},
	watch: {
		localData: {
			deep: true,
			handler(newValue) {
				console.log(newValue);
			}
		}
	}
};
</script>

<style lang="scss" scoped>
.company-advanced {
	&__items,
	&__items-edit-mode {
		display: flex;
		gap: $gutter-md;
	}

	h4 {
		margin-block-start: 0;
		margin-block-end: 0;
	}
}
</style>
